import {ApiClient} from '@hconnect/apiclient'
import {EquipmentData} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

const QueryKey = 'stoppage-equipment'

type Options<TSelect> = Omit<
  UseQueryOptions<EquipmentData[], AxiosError, TSelect>,
  'queryKey' | 'queryFn'
> & {
  onError?: (error: AxiosError) => void
}

export const useEquipments = <TSelect = EquipmentData[]>(
  plantId: string,
  searchQuery?: string,
  options?: Options<TSelect>
) => {
  const query = useQuery<EquipmentData[], AxiosError, TSelect>({
    queryKey: [QueryKey, plantId, searchQuery],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<EquipmentData[]>(
        `/downtime-dashboard/${plantId}/stoppages/equipments`,
        {
          params: searchQuery
            ? {
                query: searchQuery
              }
            : {},
          signal
        }
      )

      return response.data
    },
    staleTime: 1000 * 60 * 15, // 15 mins
    enabled: !!searchQuery,
    ...options
  })

  const onError = options?.onError

  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}
